import { downloads } from "../data";
import { Download } from "lucide-react";
import { Link } from "react-router-dom";

export default function Downloads() {
  return (
    <main data-testid="downloads-page" className="pb-12">
      <section className="border-b border-ink-700 section-padding pt-24 pb-16">
        <p className="font-mono text-[11px] tracking-[0.24em] uppercase text-textmuted mb-4">
          / downloads / archive
        </p>
        <h1 className="h-display text-5xl md:text-7xl max-w-[16ch]">
          Brochures &amp; <span className="text-signal-amber">datasheets.</span>
        </h1>
        <p className="mt-6 font-mono text-sm text-textmuted max-w-2xl leading-relaxed">
          Reference material for procurement teams. For latest pricing or sample
          datasheets of a specific SKU, please raise an enquiry.
        </p>
      </section>

      <section className="section-padding py-20">
        <div className="grid grid-cols-1 grid-cells">
          {downloads.map((d) => (
            <div
              key={d.code}
              className="p-6 lg:p-8 flex items-center justify-between gap-6 hover-lift cursor-pointer"
              data-testid={`download-${d.code.toLowerCase()}`}
            >
              <div className="flex items-center gap-6">
                <span className="font-mono text-[10px] tracking-[0.24em] uppercase text-signal-amber w-16">
                  {d.code}
                </span>
                <div>
                  <p className="font-display font-bold text-lg leading-tight">{d.name}</p>
                  <p className="font-mono text-[11px] uppercase tracking-widest text-textmuted mt-1">
                    {d.type}
                  </p>
                </div>
              </div>
              <Download size={18} className="text-textmuted" />
            </div>
          ))}
        </div>

        <p className="mt-12 font-mono text-xs text-textmuted">
          Looking for a specific datasheet?{" "}
          <Link to="/enquiry" className="text-signal-amber hover:underline">
            Send us an enquiry →
          </Link>
        </p>
      </section>
    </main>
  );
}
